export default "__VITE_ASSET__CznyQgMK__"